// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"473":"473baa56","945":"a31a36cf"}[chunkId] + ".css";
};